import { motion } from "framer-motion";
import { RESONANCE } from "../../data/homeContent";

const PHRASES = [
  "In ourselves",
  "In our relationships",
  "In how we lead",
  "In the way we gather",
  "In the way we heal",
  "In the stories we leave behind",
];

// High-impact typographic "method" moment (replaces the old group story-scroll).
export const StoryScroll = () => (
  <section id="method" data-testid="story-scroll" className="relative py-24 md:py-32 overflow-hidden">
    <div className="light-panel" />
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[46rem] h-[46rem] glow-bronze blur-3xl opacity-50 pointer-events-none" />

    <div className="relative z-10 max-w-5xl mx-auto px-5 md:px-8 text-center">
      <motion.p initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        className="text-xs md:text-sm tracking-[0.36em] uppercase text-[#9A6A2E] mb-7">
        {RESONANCE.eyebrow}
      </motion.p>

      <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.05, duration: 0.7 }}
        className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#1A1206]">
        Change the <span className="text-[#B07A2B]">resonance.</span>
        <br />
        Change what <span className="text-[#B07A2B]">becomes possible.</span>
      </motion.h2>

      <div className="gold-hairline max-w-[9rem] mx-auto my-8 md:my-10" />

      <div className="flex flex-col items-center gap-2 md:gap-3">
        {PHRASES.map((p, i) => (
          <motion.p key={p}
            initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.09, duration: 0.55 }}
            className="font-serif italic text-xl sm:text-2xl md:text-3xl text-[#3A2E1E] leading-tight">
            {p}
          </motion.p>
        ))}
      </div>
    </div>
  </section>
);

export const ResonanceNote = () => (
  <section data-testid="resonance-note" className="relative py-16 md:py-24 overflow-hidden">
    <div className="aurora-weave slow" />
    <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-8 text-center">
      <p className="text-xs md:text-sm tracking-[0.34em] uppercase text-[#E7CC86]/85 mb-6">{RESONANCE.riHeading}</p>
      <p className="text-cream/85 text-lg md:text-2xl leading-relaxed max-w-2xl mx-auto">{RESONANCE.ri}</p>
      <p className="font-serif italic text-[#E7CC86] text-lg md:text-xl mt-7 leading-relaxed max-w-2xl mx-auto">{RESONANCE.ri2}</p>
    </div>
  </section>
);
